import React from 'react';
import { useAppConfiguration } from '../../../AppConfiguration';
import {useTranslation} from '../../../config/TranslationProvider';

const Categories = ({categories, forListing, register, selected, fixed}) => {
    const {[forListing + 'FilterConfiguration']: filterConfiguration} = useAppConfiguration();
    const filterCategories = filterConfiguration.categories ? [] : categories;
    const others = [];

    if (filterConfiguration.categories) {
        for (let i = 0; i < categories.length; i++) {
            if (!filterConfiguration.categories.includes(categories[i].title)) {
                others.push(categories[i].id);
            } else {
                filterCategories.push(categories[i]);
            }
        }
    }

    const fixedCategory = fixed && Object.values(filterCategories).find(category => category.id === fixed[0]);

    return (
        <div className="form-group">
            <div className="select-basic">

                {fixed ?
                    <select
                        className="form-control"
                        name="categories"
                        ref={register}
                        defaultValue={fixed[0]}
                        aria-label="category"
                        disabled
                    >
                        <option value={fixedCategory.id}>{fixedCategory.title}</option>
                    </select>
                    :
                    <select
                        className="form-control"
                        name="categories"
                        ref={register}
                        defaultValue={selected}
                        aria-label="category"
                    >
                        <option value="">
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useTranslation('select_category')}
                        </option>
                        {filterCategories.map((value, key) => (
                            <option key={key} value={value.id}>{value.title}</option>
                        ))}
                        {others.length > 0 &&
                        <option value={others.join(',')}>
                            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
                            {useTranslation('others')}
                        </option>}
                    </select>
                }

            </div>
        </div>
    );
};

export default Categories;
